<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div *ngIf="status === 'sold'" class="d-inline-block">
  <span class="dot booked"></span>
  {{ 'NIGHT_STATUS.SOLD' | translate }}

  <a *ngIf="night?.sale_id" routerLink="/sales/view" [queryParams]="{ id: night.sale_id }" target="_blank">
    (#{{ night.sale_id }})
  </a>
</div>
<div *ngIf="status === 'available'" class="d-inline-block">
  <span class="dot available"></span>
  {{ 'NIGHT_STATUS.AVAILABLE' | translate }}
</div>
<div *ngIf="status === 'cancelled'" class="d-inline-block">
  <span class="dot cancelled"></span>
  {{ 'NIGHT_STATUS.CANCELLED' | translate }} (#{{ night.hotel_booking_cancellation_id }})
</div>
